import actions from './actionTypes';

const defaultState = null;

export default (state = defaultState, action = {}) => { 
  switch (action.type) {
    case actions.SET_SITE_USER:
      return  action.user.assetInfo.metadata.props.userId 
    case actions.SET_ORG_USER_ROLE: 
      if (action.orgUserRole.response.assetInfo.metadata.props.userId) {
        return  action.orgUserRole.response.assetInfo.metadata.props.userId
      } else {
        return  null
      }
    case actions.LOGGED_OUT:
      // Reload the app at this point in order to refresh Google Analytics. Couldn't find a way to des-initialize or close analytics in order to pick up a different User id. 
      // Meaning that if a user logs out and another logs in withount reloading the window object, Google Analytics will think is already initialized. 
      window.location.reload();
      return null
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/userId.js